<template>
  <div class="flex justify-between dynamic2-wrapper">
    <div class="flex flex-col justify-between left-wrapper">
      <div class="flex justify-between left1">
        <div class="left1-desc animate-fade-in" :key="'l1' + currentIndex">
          <img src="../../assets/images/logo-new2.png" alt="" class="mx-auto" />
          <p class="text-left p2 text-title" v-if="data[0].title">
            {{ data[0].title }}
          </p>
          <p class="p3 text-desc" v-if="data[0].desc">
            {{ data[0].desc }}
          </p>
        </div>

        <a
          class="block bg-center bg-no-repeat bg-cover left1-image animate-fade-in swiper-image"
          :key="'l2' + currentIndex"
          :href="data[0].href"
          target="_blank"
          :style="{ backgroundImage: 'url(' + data[0].image + ')' }"
        ></a>
      </div>
      <a
        class="block bg-center bg-no-repeat bg-cover left2 animate-fade-in swiper-image"
        :href="data[1].href"
        target="_blank"
        :key="'l3' + currentIndex"
        :style="{ backgroundImage: 'url(' + data[1].image + ')' }"
      >
        <div class="left2-desc">
          <p class="text-title" v-if="data[1].title">{{ data[1].title }}</p>
          <p class="text-desc" v-if="data[1].desc">
            {{ data[1].desc }}
          </p>
        </div>
      </a>
    </div>
    <div class="right-wrapper">
      <a
        class="block bg-center bg-no-repeat bg-cover item1 animate-fade-in swiper-image"
        :style="{ backgroundImage: 'url(' + data[2].image + ')' }"
        :href="data[2].href"
        target="_blank"
        :key="'l4' + currentIndex"
      >
        <div class="item1-desc">
          <p class="text-title" v-if="data[2].title">{{ data[2].title }}</p>
          <p class="text-desc" v-if="data[2].desc">
            {{ data[2].desc }}
          </p>
        </div>
      </a>
      <a
        class="flex items-end block item2 animate-fade-in"
        :href="data[3].href"
        target="_blank"
        :key="'l5' + currentIndex"
      >
        <div class="item2-image">
          <div
            class="bg-center bg-no-repeat bg-cover image swiper-image"
            :style="{ backgroundImage: 'url(' + data[3].image + ')' }"
          ></div>
        </div>
        <div class="flex-1 desc">
          <div class="text-title" v-if="data[3].title">
            {{ data[3].title }}
          </div>
          <div class="text-desc" v-if="data[3].desc">
            {{ data[3].desc }}
          </div>
        </div>
      </a>
      <a
        class="flex items-end block item3 animate-fade-in"
        :href="data[4].href"
        target="_blank"
        :key="'l6' + currentIndex"
      >
        <div
          class="bg-center bg-no-repeat bg-cover item3-image swiper-image"
          :style="{ backgroundImage: 'url(' + data[4].image + ')' }"
        ></div>
        <div class="flex-1">
          <div class="text-title" v-if="data[4].title">
            {{ data[4].title }}
          </div>
          <div class="text-desc" v-if="data[4].desc">
            {{ data[4].desc }}
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data', 'currentIndex'],
  watch: {
    currentIndex: {
      handler(val) {
        // console.log('====dynamic2====' + val)
      },
      immediate: true
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="less">
@keyframes scaleTranslateXRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.dynamic2-wrapper {
  width: 90vw;
  margin: auto;
  margin-top: 5vh;
  height: 68vh;
  .swiper-image {
    transition: background-size 0.3s ease-in-out;
    will-change: background-size;
    background-size: 100%;
    &:hover {
      background-size: 120%;
    }
  }
  .animate-fade-in {
    animation: scaleTranslateXRight 2s ease-in-out;
  }
  .text-title {
    font-size: 1.1vw;
    font-weight: bold;
    margin-bottom: 1vh;
  }
  .text-desc {
    font-size: 1vw;
  }
  .left-wrapper {
    flex: 1;
    margin-right: 10px;
    .left1 {
      height: 100%;
      margin-bottom: 10px;
      .left1-desc {
        margin-right: 10px;
        width: 10vw;
        img {
          width: 12vw;
          display: block;
          margin-bottom: 20px;
        }
        .p1 {
          padding-bottom: 2px;
          border-bottom: 3px solid rgba(253, 183, 50, 1);
          margin-bottom: 20px;
        }
      }

      .left1-image {
        width: 40vw;
        height: 33.5vh;
      }
    }
    .left2 {
      // width: 26.5vw;
      height: 100%;
      position: relative;
      .left2-desc {
        position: absolute;
        left: 1.7vw;
        bottom: 24px;
        color: white;
        padding: 19px;
        width: 12.3vw;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }

  .right-wrapper {
    width: 40vw;
    .item1 {
      width: 100%;
      height: 30vh;
      position: relative;
      .item1-desc {
        position: absolute;
        top: 30px;
        right: 30px;
        width: 12.32vw;
        padding: 19px;
        color: white;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
    .item2 {
      width: 100%;
      position: relative;
      top: -8vh;
      .item2-image {
        width: 22.12vw;
        height: 23vh;
        padding: 0.9vw 0.9vw 0 0;
        background-color: white;
        .image {
          width: 100%;
          height: 100%;
          margin-right: 0.9vw;
        }
      }
    }
    .item3 {
      width: 100%;
      height: 21vh;
      position: relative;
      top: -6vh;
      .item3-image {
        width: 21vw;
        height: 100%;
        margin-right: 0.9vw;
      }
    }
  }
}
</style>
